export enum SectionLogo {
    footer = 'footer',
}
